export class Rule {
  required: boolean;
  range:  any;
  MOD97: boolean;
  regex: any;

  constructor(options: {
    required?: boolean,
    range?:  { min: string, max: string },
    regex?: any,
   } = {} ) {
    this.required = !!options.required;
    this.regex = options.regex || '';
    this.range = options.range || null;
   }

  setRequired(required: boolean){
    this.required = required;
  }

  setRange(minValue:string, maxValue:string){
    this.range = new Object()
    this.range.min = minValue;
    this.range.max = maxValue;    
  }

  setRegex(regex: any){
    this.regex = regex;
  }

  setMOD97(MOD97: boolean){
    this.MOD97 = MOD97;
  }
}
